import PropTypes from 'prop-types';
import React from 'react';
import Ibox from 'lib/components/Ibox';
import { FAIcon } from 'reactifi';

export default class PlaylistItem extends React.Component {

  static propTypes = {
    name: PropTypes.string,
    description: PropTypes.string,
    image_url: PropTypes.string,
    onDeleteItem: PropTypes.func,
    id: PropTypes.number
  }

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id={this.props.id}>
        <Ibox showTitle={false}>
          <div className="row">
            <div className="col-2">
              <img className="rounded img-small" src={this.props.image_url} />
            </div>
            <div className="col-8">
              <h3 className="m-t-0">{this.props.name}</h3>
              <p>{this.props.description}</p>
            </div>
            <div className="col-2">
              <a className="btn" onClick={this.props.onDeleteItem}><FAIcon icon="trash" /></a>
              <button className="btn btn-outline"><FAIcon icon="bars" additionalClasses="text-info content-drag-handle" /></button>
            </div>
          </div>
        </Ibox>
      </div>
    )
  }
}
